import * as MO from '@effect-ts/morphic'

const Evaluation_ = MO.make(F =>
  F.interface(
    {
      // TODO: incomplete...
      evaluator_email: F.nullable(F.string()),
      evaluator_name: F.nullable(F.string()),
      would_recommend: F.nullable(F.boolean())
    },
    { name: 'Evaluation' }
  )
)

export interface Evaluation extends MO.AType<typeof Evaluation_> {}
export interface EvaluationRaw extends MO.EType<typeof Evaluation_> {}
export const Evaluation = MO.opaque<EvaluationRaw, Evaluation>()(Evaluation_)

const Evaluations_ = MO.make(F => F.array(Evaluation(F)))
export interface Evaluations extends MO.AType<typeof Evaluations_> {}
export interface EvaluationsRaw extends MO.EType<typeof Evaluations_> {}
export const Evaluations = MO.opaque<EvaluationsRaw, Evaluations>()(Evaluations_)
